import { useWSMutation } from "../../helpers";
import { QUERY_REQUIREMENT_DEFINITIONS_LIST } from "../keys";
import { deleteRequirementDefinition } from "../../../services/requirementDefinitions/deleteRequirementDefinition";

export const useMutationDeleteRequirementDefinition = () =>
  useWSMutation((id: string) => deleteRequirementDefinition(id), {
    dependencies: [QUERY_REQUIREMENT_DEFINITIONS_LIST]
  });
